import { Api, Config } from './api'

export const ApiObterUnidadeLotacao = async () => {
   const { data } = await Api.get(`/unidades-lotacao?ordenar=descricao&limite=1000`, Config())

   return data
}
